import { CreditProductReadModel } from "services/creditProduct";
import { object } from "yup";

export const simulationDetailsSchema = () => {
    return object().shape({});
};

export const simulationDetailsDefaultValues = (data?: CreditProductReadModel | null) =>{
    return {}
}